/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Feedback_Yes_Option_Part1Inputs */

const en_ai_feedback_yes_option_part1 = /** @type {(inputs: Ai_Feedback_Yes_Option_Part1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, I want to receive AI-based feedback and agree to the transmission of my resume to our data processors. I have read the `)
};

const de_ai_feedback_yes_option_part1 = /** @type {(inputs: Ai_Feedback_Yes_Option_Part1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, ich möchte KI-basiertes Feedback erhalten und erkläre mich mit der Übermittlung meines Lebenslaufs an unsere Subdienstleister einverstanden. Die `)
};

/**
* | output |
* | --- |
* | "Yes, I want to receive AI-based feedback and agree to the transmission of my resume to our data processors. I have read the" |
*
* @param {Ai_Feedback_Yes_Option_Part1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_feedback_yes_option_part1 = /** @type {((inputs?: Ai_Feedback_Yes_Option_Part1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Feedback_Yes_Option_Part1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_feedback_yes_option_part1(inputs)
	return en_ai_feedback_yes_option_part1(inputs)
});